var burgerIcon = document.getElementById("burgerIcon");
var burgerWrapper = document.getElementById("burgerWrapper");
var navbarUL = document.getElementById("navbarUL");

burgerWrapper.addEventListener("click", menuAnimation);

function menuAnimation() {
    burgerIcon.classList.toggle("close");
    navbarUL.classList.toggle("is-collapsed");
}